import { createAction, props } from '@ngrx/store';
import { GoalStatus } from 'src/app/shared/types/goals';

export const LoadGoalStatuses = createAction('[GoalStatus] Load GoalStatuses');
export const LoadGoalStatusesSuccess = createAction('[GoalStatus] Load GoalStatuses Success', props<{ goalStatuses: GoalStatus[] }>());
export const LoadGoalStatusesFailure = createAction('[GoalStatus] Load GoalStatuses Failure', props<{ error: string }>());
